import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container, ModalBody, Modal } from 'reactstrap';
import { Card } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useParams, useLocation } from 'react-router-dom';
import { requisition_create } from '../../api/requisition';
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from 'react-toastify';
import LinearProgress from '@mui/material/LinearProgress';
import { useNavigate } from 'react-router-dom';
import {formatValueWithCommas} from '../helper'
import { StorePageHeaderName } from '../../store/pageHeader/action';
import { useSelector, useDispatch } from "react-redux";

const AddRequisition = () => {
    const loggedInUser = useSelector((state) => state.Profile.user);
    const dispatch = useDispatch();

    const location = useLocation();
    const [requisition, setRequisition] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
    const [requisitionNumber, setRequisitionNumber] = useState(null); // New state variable for requisition number

    const navigate = useNavigate();

    useEffect(()=>{
        dispatch(StorePageHeaderName('Add Requisition'))

    },[])

    useEffect(() => {
        if (location.state && location.state.requisition) {
            setRequisition(location.state.requisition);
        }
    }, [location.state]);
    useEffect(() => {
        let quantitySum = 0;
        let valueSum = 0;
        requisition.forEach(row => {
            quantitySum += row.quantity;
            valueSum += row.value;
        });
        setTotalQuantity(quantitySum);
        setTotalValue(valueSum);
    }, [requisition]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const handleNoButtonClick = () => {
        closeModal(); // Closing the modal when 'No' button is clicked
    };
    const handleCreateRequisition = async() =>{
        try{
            closeModal(); // Closing the modal when 'No' button is clicked
            setIsLoading(true)
            console.log('hiiii',requisition)
            const reqStructure = {
                requisition_data:[
                    {
                       user_id: loggedInUser.userDetails.id,
                       req_total: totalValue,
                       req_item_count: totalQuantity,
                        items: requisition.map(item => ({
                            total_qty: item.quantity,
                            value: item.value,
                            item_name: item.productObj.productName,
                            item_no: item.productObj.value,
                            p_type: item.productObj.Ptype,
                            vertical: item.productObj.Vertical,
                            itemseg: item.productObj.Itemseg,
                            category: item.productObj.Category,
                            dp: item.productObj.Dp,
                            mop: item.productObj.Mop,
                            vcode: item.productObj.vcode,
                            vname: item.productObj.vname,
                            vtype: item.productObj.vtype

                        }))
                    }
                ],
              }


           const createReq = await requisition_create(reqStructure)


           if(createReq.statusCode === 201) {
            setRequisitionNumber(createReq.requisition_number); // Store requisition number

            setIsOpenSweetAlert(true);

           }

        } catch (error) {
            console.error('Failed to create requisition', error);
            toast.error('Something went wrong')

        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    }
    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);

        navigate("/executive/requisition-history");

    };


    
    const handleNavigate = () => {
        navigate('/executive/create-requisition', { state: { prevRoute: '/executive/add-requisition' }});
    };
    
    return (
        <React.Fragment>
          
            <div className="page-content">
                <Container fluid>
                {isLoading && ( // Conditional rendering of loader
                <div className="loader-container">
                    <LinearProgress />
                </div>
                )}
                    <div className='mb-3' style={{ fontSize: '20px', fontWeight:'500' }}>
                        <span className='me-2'   onClick={handleNavigate}><ArrowBackIcon /></span>
                        <span>Requisition</span>
                    </div>
                    <Card>
                        <CardBody>
                            <div>

                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product Name</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                    {requisition.map((row, index) => (
                                        <tr key={index}>
                                            <td>{index+1}</td>
                                            <td>{row.productName}</td>
                                            <td>{row.quantity}</td>
                                            <td>{formatValueWithCommas(row.value)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colspan="2">Total :</th>
                                            <td>{totalQuantity}</td>
                                            <td>{formatValueWithCommas(totalValue)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                    <div className='mb-2' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', marginRight: '8px', marginBottom: '3px', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
                        <Button className="save_button" variant="contained" onClick={openModal}>Submit</Button>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do You Want To Submit This Requsition</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div>
                        <div>
                            <p className='mb-0'>If 'Yes', then you won't be able to modify or edit your request or If 'No' , then you can continue your modification.</p>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={handleCreateRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={handleNoButtonClick}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title='Requisition created successfully'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
}

export default AddRequisition;
